import LoaderButton from 'components/LoaderButton'
import PropTypes from 'prop-types'
import React from 'react'
import { Alert, Button } from 'react-bootstrap'
import Modal from 'react-bootstrap/Modal'

function HideWidgetsModal({ show, onHide, slide, loading, onSubmit, errorMessage = '' }) {
  const enabling = !slide?.hide_widgets

  const title = enabling ? 'Enable fullscreen mode' : 'Disable fullscreen mode'
  const body = enabling
    ? "This slide will display without the widget frame, regardless of the screen's widget settings."
    : "This slide will display with the screen's widget frame if it has one enabled."
  const confirmLabel = enabling ? 'Enable' : 'Disable'

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{body}</p>
        {errorMessage && <Alert variant='danger'>{errorMessage}</Alert>}
      </Modal.Body>
      <Modal.Footer>
        <Button disabled={loading} variant='secondary' onClick={onHide}>
          Cancel
        </Button>
        <LoaderButton
          loading={loading}
          label={confirmLabel}
          variant='success'
          onClick={onSubmit}
        />
      </Modal.Footer>
    </Modal>
  )
}

HideWidgetsModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  slide: PropTypes.object,
  loading: PropTypes.bool,
  onSubmit: PropTypes.func,
  errorMessage: PropTypes.string,
}

HideWidgetsModal.defaultProps = {
  show: false,
  loading: false,
  errorMessage: '',
}

export default HideWidgetsModal
